import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { isEmpty, keys, pickBy } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';
import useWindowSize from '../../../hooks/useWindowSize';

import queryString from 'query-string';

import { array } from 'prop-types';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobModal from '../../../components/BobModal';
import CreateEquipmentOrSystemModal from '../EquipmentPage/CreateEquipmentOrSystemModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import DeleteEquipmentModal from '../EquipmentPage/DeleteEquipmentModal';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';

import classes from './Table.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const EquipmentTable = ({
    activeTab,
    activeNavClient,
    activeNavCompany,
    bobLoading,
    clientEquipment,
    clientEquipmentMeta,
    createEquipmentModalOpen,
    companies,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    deleteEquipmentModalOpen,
    equipment,
    equipmentFilters,
    fetchDashboardData,
    fetchNavClients,
    fetchSingleEquipment,
    history,
    handleToggleCreateEquipmentModal,
    handleToggleDeleteEquipmentModal,
    handleToggleSubscribeToEquipmentAlertsModal,
    resetNavOptions,
    refreshTab,
    setRefreshTab,
    setNavCompany,
    setTableProps,
    searchTerm,
    subscribeToAlertsEqquipmentModalOpen,
    targetNavCompany,
    totalsData,
    workbookModeEnabled,
    ...props
}) => {
    const [typeFilters, setTypeFilters] = useState([]);
    const [priorityFilters, setPriorityFilters] = useState([]);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [equipmentData, setEquipmentData] = useState(null);
    const [equipmentColumnWidth, setEquipmentColumnWidth] = useState(250);
    const [dataState, setDataState] = useState(initialDataState);

    const queryValues = queryString.parse(history.location.search);
    const companyId = queryValues.company;
    const clientId = queryValues.client;

    const isInitialMount = useRef(true);
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = columnList.map((c) => {
            c.width = c.field === 'equipmentName' ? 250 : c.width;
            if (c.field.toLowerCase().includes('faultcount')) {
                c.show = dashboardIsCurrentTimeStamp;
            }
            else {
                c.show = true;
            }
            return c;
        });
        const colWidth = calculateMinColumnWidths(columns.filter(c => c.show), gridDivRef.current.offsetWidth, 'equipmentName', 350, true);
        setEquipmentColumnWidth(colWidth);
        columns.find(c => c.id === 'equipmentColumn').width = colWidth;
        setColumnList(columns);
    }, [windowSize, dashboardIsCurrentTimeStamp]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
        setColumnList(columnList.map(c => {
            c.filterable = c.actionCell ? false : workbookModeEnabled;
            return c;
        }));
    }, [workbookModeEnabled]);

    useEffect(() => {
        if (equipmentFilters.type || Object.values(equipmentFilters.priority).includes(true)) {
            const typeFilters = equipmentFilters.type.map(filter => filter.id);
            const priorityFilters = keys(pickBy(equipmentFilters.priority));

            setTypeFilters(typeFilters);
            setPriorityFilters(priorityFilters);
        }
    }, []);

    useEffect(() => {
        if (activeNavClient && activeNavClient.id && isEmpty(clientEquipment)) {
            initializeFetch();
        }
    }, [activeNavClient]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            if (equipmentFilters.type || Object.values(equipmentFilters.priority).includes(true)) {
                if (!isEmpty(targetNavCompany) && !isEmpty(clientEquipmentMeta)) {
                    initializeFetch();
                }
            } else {
                const init = async () => {
                    initializeFetch();
                };
                
                if (activeNavClient.id && !isEmpty(clientEquipment)) init();
            }
        }
    }, [equipmentFilters, dashboardStartTimeStamp, dashboardEndTimeStamp, searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            await fetchDashboardData(activeNavCompany.id, 'ClientEquipment', { clientId: activeNavClient.id, sort: 'equipmentScore^desc', startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
            setRefreshTab();
        };

        if (refreshTab) refresh();
    }, [refreshTab]);
    
    const initializeFetch = async () => {
        const typeFilters = equipmentFilters.type.map(filter => filter.id);
        const priorityFilters = keys(pickBy(equipmentFilters.priority));

        setTypeFilters(typeFilters);
        setPriorityFilters(priorityFilters);

        await fetchDashboardData(activeNavCompany.id, 'ClientEquipment', { clientId: activeNavClient.id, sort: 'equipmentScore^desc', startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const fetchEquipmentListAfterCreate = async searchTerm => {
        await fetchDashboardData(activeNavCompany.id, 'ClientEquipment', { clientId: activeNavClient.id, sort: 'equipmentScore^desc', startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `equipment?client=${dataItem.clientId}&company=${queryValues.company}&equipment=${dataItem.equipmentId}&site=${dataItem.siteId}`;
    };

    const renderScoreNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `equipment?client=${dataItem.clientId}&company=${queryValues.company}&equipment=${dataItem.equipmentId}&site=${dataItem.siteId}&viewChildId=4b25aeb8-45d4-4522-9f77-870ab40abb07`;
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/equipment';

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;
        queryValues.equipment = dataItem.equipmentId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        const options = {extendedData: true};
        await fetchSingleEquipment(queryValues, options);
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <Link
                    to={renderNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const areaCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <HtmlTooltip
                    information={props.dataItem[props.field]}
                    placement={'top'}
                    body={
                        <div id={props.dataItem['equipmentId']} className={classes.AreaText}>
                            {props.dataItem[props.field]}
                        </div>
                    }
                    disableHoverStatus={props.dataItem['areas'] && props.dataItem['areas'].length <= 2 ? true : false}
                />
            </td>
        );
    };

    const scoresCell = props => {
        let value = props.dataItem[props.field];
        value = value.toString().includes('.') ? parseFloat(value).toFixed(2) : value;
        return (
            <td className={props.className} style={props.style}>
                <Link
                    to={renderScoreNavUrl(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {value + '%'}
                </Link>
            </td>
        );
    };

    const fetchEquipmentDataForDelete = (equipmentData) => {
        setEquipmentData(equipmentData);
        handleToggleDeleteEquipmentModal(true);
    };

    const subscribeEquipmentData = (equipmentData) => {
        equipmentData.name = equipmentData.equipmentName;
        equipmentData.id = equipmentData.equipmentId;

        setEquipmentData(equipmentData);
        handleToggleSubscribeToEquipmentAlertsModal(true);
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    entityData={props.dataItem}
                    onSubscribeAlerts={(entityData) => { subscribeEquipmentData(entityData); }}
                    onDelete={(entityData) => fetchEquipmentDataForDelete(entityData)}
                    onFetch={(entityData) => handleEditEquipment(entityData)}
                />
            </td>
        );
    };

    const handleEditEquipment = equipmentData => {
        setEquipmentData(equipmentData);
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=7e2354df-ebb5-4c68-a1a4-57cc84dd61eb&client=${activeNavClient.id}&company=${activeNavCompany.id}&entityId=${equipmentData.equipmentId}&entityType=equipment&parentId=3ee59a8f-d13a-475b-b424-ee55eef98a65`,
                state:    { 'returnUrl': `/v2/dashboard/client?appId=${bob.key}&childId=8404408d-ad6f-472e-b9dd-34383b392178&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=a73c8c70-35aa-48b7-a797-4c607ae25280` }
            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const fetchEquipments = async searchTerm => {
        await fetchDashboardData(companyId, 'ClientEquipment', { clientId, sort: 'equipmentScore^desc', startDate: dashboardStartTimeStamp, endDate: dashboardEndTimeStamp, excludeFault: !dashboardIsCurrentTimeStamp }, typeFilters, priorityFilters);
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const priorityCell = props => {
        let imgPath = '/assets/images/low.svg';
        if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }
        return (
            <td className={props.className} style={props.style}>
                <img className={ props.dataItem[props.field] > 0 ? classes.IconImage: classes.IconImageGray} src={imgPath} alt="" />
                {props.dataItem[props.field]}
            </td>
        );
    };

    const actionFilterCell = props => {
        return (
            <div />
        );
    };
    
    const defaultColumnList = [
        {
            title:       dashboardContent.equipment,
            field:       'equipmentName',
            id:          'equipmentColumn',
            cell:        nameCell,
            width:       250,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: false
        },
        {
            title:       dashboardContent.client,
            field:       'clientName',
            width:       300,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.site,
            field:       'siteName',
            width:       300,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.equipmentType,
            field:       'equipmentTypeName',
            width:       250,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.area,
            field:       'areaList',
            cell:        areaCell,
            width:       250,
            show:        true,
            filter:      'text',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.sensors,
            field:       'sensorCount',
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.score,
            field:       'equipmentScore',
            cell:        scoresCell,
            width:       175,
            show:        true,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.faults,
            field:       'totalFaultCount',
            width:       175,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.high,
            field:       'highFaultCount',
            width:       175,
            cell:        priorityCell,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.medium,
            field:       'mediumFaultCount',
            width:       175,
            cell:        priorityCell,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       dashboardContent.low,
            field:       'lowFaultCount',
            width:       175,
            cell:        priorityCell,
            show:        dashboardIsCurrentTimeStamp,
            filter:      'numeric',
            sortable:    true,
            filterable:  workbookModeEnabled,
            locked:      false,
            reorderable: true
        },
        {
            title:       '',
            field:       '',
            cell:        actionsCell,
            locked:      true,
            sortable:    false,
            filterable:  false,
            filterCell:  actionFilterCell,
            width:       75,
            show:        true,
            actionCell:  true,
            reorderable: false
        }
    ];
    const [columnList, setColumnList] = useState(defaultColumnList);

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef} 
                    sortable={{
                        mode: 'multiple'
                    }}
                    filterable={workbookModeEnabled}
                    className={classes.KendoGrid}
                    data={kendoProcess(clientEquipment, dataState)}
                    {...dataState}
                    onDataStateChange={onDataStateChange}
                    pageable={pageable}
                    reorderable
                >
                    {
                        bobLoading.includes('ClientEquipment') || isEmpty(clientEquipmentMeta) ?
                            <GridNoRecords>
                                Loading equipment
                            </GridNoRecords>
                            :
                            null
                    }
                    {
                        columnList.map(
                            (column, index) => 
                                column.show && (
                                    <Column
                                        key={index}
                                        field={column.field}
                                        title={column.title}
                                        id={column.id}
                                        cell={column.cell}
                                        width={column.id === 'equipmentColumn' ? equipmentColumnWidth : column.width}
                                        filter={column.filter}
                                        filterCell={column.filterCell}
                                        sortable={column.sortable}
                                        filterable={column.filterable}
                                        locked={column.locked}
                                        reorderable={column.reorderable}
                                    />
                                )
                        )
                    }     
                </Grid>
                {
                    subscribeToAlertsEqquipmentModalOpen ?
                        <CreateSubscriptionModal
                            parent={equipmentData}
                            parentLabel="Equipment"
                            handleToggleSubscribeToAlertsModal={handleToggleSubscribeToEquipmentAlertsModal}
                        />
                        :
                        null
                }
                {
                    createEquipmentModalOpen ?
                        <BobModal
                            title={ equipmentData ? 'Edit Equipment' : 'Add New Equipment'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                setEquipmentData(null);
                                handleToggleCreateEquipmentModal(false);}}
                        >
                            <CreateEquipmentOrSystemModal
                                equipment={equipmentData}
                                isEdit={equipmentData ? true : false}
                                fetchEquipmentListAfterCreate={(name) => fetchEquipmentListAfterCreate(name)}
                                onClose={() => {
                                    setEquipmentData(null);
                                    handleToggleCreateEquipmentModal(false);}}
                            />
                        </BobModal> : ''
                }
                {
                    deleteEquipmentModalOpen ?
                        <BobModal
                            title={'Delete Entity'}
                            hidebuttons={true}
                            isRemoveFooter={true}
                            onClose={() => {
                                handleToggleDeleteEquipmentModal(false);
                                setEquipmentData(null);}}
                        >
                            <DeleteEquipmentModal
                                equipment={equipmentData}
                                fetchEquipments={fetchEquipments}
                                onClose={() => {
                                    handleToggleDeleteEquipmentModal(false);
                                    setEquipmentData(null);}}
                            />
                        </BobModal> : ''
                }
                {
                    bobLoading.includes('ClientEquipment') || isEmpty(clientEquipmentMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

EquipmentTable.defaultProps = {
    clientEquipment: []
};

EquipmentTable.propTypes = {
    clientEquipment: array
};

const mapStateToProps = state => ({
    activeNavClient:             state.bob.activeNavClient,
    activeNavCompany:            state.bob.activeNavCompany,
    bobLoading:                  state.bob.bobLoading,
    clientEquipment:             state.dashboard.clientEquipment,
    clientEquipmentMeta:         state.dashboard.clientEquipmentMeta,
    clientTabIndex:              state.dashboard.clientTabIndex,
    companies:                   state.core.companies,
    dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
    dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    equipmentFilters:            state.dashboard.equipmentFilters,
    targetNavCompany:            state.bob.targetNavCompany
});

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EquipmentTable));
